import { AxiosResponse } from 'axios'
import { api } from 'API'
import {
  IPlayerAssignment,
  IPlayerAssignmentSearchFilter,
  IPlayerAssignmentOverview,
  IPlayerWeekDetailResponse,
  IPlayerStationDetailResponse
} from 'interfaces/player-assignment'

const BASE = '/player/assignments'

export interface IToggleDrillCompletionResponse {
  autoAdvancedWeek: boolean
  nextWeekId: number | null
  nextWeekNumber: number | null
  weekCompleted: boolean
}

export async function getMyAssignments(
  filter: IPlayerAssignmentSearchFilter = {}
): Promise<{ results: IPlayerAssignment[]; totalCount: number }> {
  const response: AxiosResponse = await api.post(`${BASE}/search`, filter)
  return response.data
}

export async function updateDrillCompletion(
  assignmentId: number,
  drillId: number,
  isCompleted: boolean
): Promise<IToggleDrillCompletionResponse> {
  const response: AxiosResponse = await api.patch(`${BASE}/${assignmentId}/drills/${drillId}/completion`, { isCompleted })
  return response.data
}

export async function submitDrillMetrics(
  assignmentId: number,
  drillId: number,
  metrics: Array<{ metricId: number; value: string | number }>
): Promise<void> {
  await api.post(`${BASE}/drills/${drillId}/metrics?assignmentId=${assignmentId}`, { metrics })
}

export async function uploadDrillVideo(
  assignmentId: number,
  drillId: number,
  formData: FormData
): Promise<{ url: string; mediaId: number }> {
  const response: AxiosResponse = await api.post(`${BASE}/drills/${drillId}/video?assignmentId=${assignmentId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
  return response.data
}

export async function submitDrillVideo(
  assignmentId: number,
  drillId: number,
  videoFileName?: string,
  note?: string
): Promise<{ url: string; mediaId?: number }> {
  const response: AxiosResponse = await api.post(`${BASE}/drills/${drillId}/video?assignmentId=${assignmentId}`, {
    videoFileName,
    note
  })
  return response.data
}

export async function getPlayerAssignmentOverview(assignmentId: number): Promise<IPlayerAssignmentOverview> {
  const response: AxiosResponse = await api.get(`${BASE}/${assignmentId}/overview`)
  return response.data
}

export async function getPlayerWeekDetail(assignmentId: number, weekId: number): Promise<IPlayerWeekDetailResponse> {
  const response: AxiosResponse = await api.get(`${BASE}/${assignmentId}/weeks/${weekId}`)
  return response.data
}

export async function getPlayerStationDetail(assignmentId: number, stationId: number): Promise<IPlayerStationDetailResponse> {
  const response: AxiosResponse = await api.get(`${BASE}/${assignmentId}/stations/${stationId}`)
  return response.data
}
